//IE11 swiper js 'startsWith' Polyfill
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position){
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
};
}

var swiper = new Swiper('.bedding-swiper-linens .swiper-container',{
  slidesPerView: 2,
  spaceBetween:20,
  loop: true,
  navigation: {
    nextEl: '#prev-linens',
    prevEl: '#next-linens',
  },
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  breakpoints: {       
    960: {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
    }
  }
});

var swiper = new Swiper('.bedding-swiper-pillows .swiper-container',{
  slidesPerView: 2,
  spaceBetween:20,
  loop: true,
  navigation: {
    nextEl: '#prev-pillows',
    prevEl: '#next-pillows',
  },
  a11y: {
    enabled: true,
    slideLabelMessage: ""
  },
  breakpoints: {       
    960: {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 20,
    }
  }
});

  var swiperfragranceimg = new Swiper('.fragrance-swiper-image .swiper-container',{
    slidesPerView: 1,
    spaceBetween:0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.swiper-pagination',
			clickable: true,
    },
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
    breakpoints: {       
      960: {
        slidesPerView: 1,
        spaceBetween: 0,
      }
    }
  });

  var swiperfragrancetext = new Swiper('.fragrance-swiper-text .swiper-container',{
    slidesPerView: 1,
    spaceBetween:0,
    pagination: {
      el: '.swiper-pagination',
			clickable: true,
    },
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
    breakpoints: {       
      960: {
        slidesPerView: 1,
        spaceBetween: 0,
      }
    }
  });

  var swiper = new Swiper('.fragrance-swiper-mobile .swiper-container',{
    slidesPerView: 1,
    spaceBetween:0,
    loop: true,
    navigation: {
      nextEl: '#prev-fragrance',
      prevEl: '#next-fragrance',
    },
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
    breakpoints: {       
      480: {
        slidesPerView: 2,
        spaceBetween: 20,
      }
    }
  });

  var swiper = new Swiper('.item-image .swiper-container', {
    slidesPerView: 1,
    spaceBetween: 0,
    a11y: {
      enabled: true,
      slideLabelMessage: ""
    },
    watchOverflow:true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
